import BreadcrumbCRM from "./BreadcrumbCRM";
import { Form } from "react-bootstrap";
import { Col, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getMarcas } from "../../services/MarcasService";
import MaoTable from "../common/MaoTable";
import { useNavigate } from "react-router-dom";
import { FaMagnifyingGlassChart, FaClipboardList } from "react-icons/fa6";
import { HiAnnotation } from "react-icons/hi";

export default function MarcasCRM() {
    const [marcas, setMarcas] = useState([]);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        buscar();
    }, [])

    async function buscar() {
        let nombreParam = document.getElementById("txtNombre").value;
        let inactivosParam = document.getElementById("chkIncluirInactivos").checked;
        let resp = await getMarcas(nombreParam, inactivosParam);
        console.log(resp)
        if (resp.error) {
            setError(resp.message);
            setMarcas([]);
        } else {
            setError("");
            setMarcas(resp.data);
        }
    }

    async function resenia(id) {
        navigate("/crm/marcas/resenia/"+id);
    }

    const columnas = [
        {
            titulo:"Marca",
            atributo:"nombre"
        },
        {
            titulo:"Teléfono",
            atributo:"telefono"
        },
        {
            titulo:"Cuidad",
            atributo:"ciudad",
            className:"d-none d-md-table-cell"
        },
        {
            titulo:"Email",
            atributo:"email",
            className:"d-none d-md-table-cell"
        },
        {
            titulo:"Estado",
            atributo:"estado"
        }
    ]

    return <>
        <BreadcrumbCRM active="Marcas - Consulta"/>
        <Form>
        <Row className="align-items-center">
                <Col xs="auto" md="6">
                <InputGroup className="mb-2">
                <Form.Label htmlFor="inlineFormInput" visuallyHidden>
                    Nombre
                </Form.Label>
                <Form.Control
                    id="txtNombre" 
                    placeholder="Nombre a buscar..."
                />
                <Button id="btnBuscar" onClick={buscar}>
                    Buscar
                </Button>
                </InputGroup>
                </Col>
                <Col xs="auto">
                    <Form.Check
                        type="checkbox"
                        id="chkIncluirInactivos"
                        className="mb-2"
                        label="Incluir inactivos"
                        onClick={buscar}
                    />
                </Col>
            </Row>
            {error!==''?
                <Row>
                    <Col xs="auto">
                        <Alert variant="danger" key="danger">{error}</Alert>
                    </Col>
                </Row>:
                <></>
            }
        </Form>
        <MaoTable 
            columnas={columnas} 
            datos={marcas} 
            colId="marca_id"
            colEstado="estado"
            otrasAcciones={[
                {title:"Reseña", icon:<FaMagnifyingGlassChart />, click: resenia},
                /* {title:"Historial", icon: <FaClipboardList/>, click: historial},
                {title:"Notas", icon: <HiAnnotation/>, click: notas} */
            ]}>
        </MaoTable>
    </>
}